
const formatMoney = (value) => {
    let formatter =  new Intl.NumberFormat([], {
        style: 'currency',
        currency: 'BRL'
    });

    return formatter.format(value);
}

export default formatMoney;


